module.exports = __webpack_public_path__ + "img/cnc-04-compare-02.550046ca.jpg";